import styled from 'styled-components'
import { withProp, ifProp } from 'styled-tools'
import { Link } from 'react-router-dom'
import Button from '../../components/Button'
import { PopupDefaultContainer } from '../../components/popup/styled-components'
import dropdownArrow from '@images/downarrow.svg'
import clearTextIcon from './images/icon_56_clear_text.svg'
import HelpCenterLink from '../../components/help-center-link'
import colorsOptions from '../../components/stories/fundamentals/colors-styles/constants'
import {
  textStyleSizeOptions,
  textStyleWeightOptions,
  textStyleSizeStyleOptions,
  textStyleWeightStyleOptions
} from '../../components/stories/fundamentals/text-styles/constants'

export const TopSection = styled.div`
  &:after {
    content: ' ';
    display: block;
    clear: both;
    visibility: hidden;
    line-height: 0;
    height: 0;
  }
`
export const LeftBarText = styled.div`
  float: left;
  width: 58%;
  @media (min-width: 768px) and (max-width: 1024px) {
    width: 44%;
  }
`

export const RightMenu = styled.div`
  width: 42%;
  float: right;
  margin-top: 32px;
  text-align: right;
  @media (min-width: 768px) and (max-width: 1024px) {
    width: 56%;
  }
`

export const Anchor = styled.a`
  color: ${colorsOptions.greys['grey-100']};
  border-radius: 40px;
  background: ${colorsOptions.greys.white};
  display: block;
  float: left;
  width: 40px;
  height: 40px;
  text-align: center;
  cursor: pointer;
  margin: 0 auto;
  letter-spacing: 1px;
  box-shadow: 0px 1px 5px 0px rgba(20, 26, 33, 0.2);
  @media (max-width: 767px) {
    border: 0;
    width: 40px;
    height: 40px;
    box-shadow: none;
    float: right;
    background: none;
    margin-top: -10px;
  }
`

export const SubmenusLink = styled.ul`
  padding: 0;
  margin: 0;
  width: 40px;
  display: inline-block;
  position: relative;
  margin-right: 16px;
  @media (max-width: 767px) {
    float: right;
    margin-right: 0px;
  }
  li {
    list-style-type: none;
    text-align: left;
    ul {
      display: inline-block;
      padding: 0px;
      margin: 0;
      position: absolute;
      top: 49px;
      right: 0px;
      left: auto;
      width: 288px;
      border: 1px solid ${colorsOptions.greys['grey-20']};
      box-shadow: 0px 1px 5px 0px rgba(20, 26, 33, 0.2);
      z-index: 1003;
      @media (max-width: 767px) {
        top: 40px;
        width: 289px;
      }
      &:after {
        position: absolute;
        right: 8px;
        top: -11px;
        width: 0;
        height: 0;
        content: '';
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 10px solid ${colorsOptions.greys['grey-20']};
      }

      &:before {
        content: '';
        position: absolute;
        right: 8px;
        top: -9px;
        width: 0;
        height: 0;
        content: '';
        border-style: solid;
        border-width: 0 10px 10px 10px;
        border-color: transparent transparent #fff transparent;
        z-index: 3;
      }
      &:hover {
        &:before {
          border: none;
        }
      }
      li {
        list-style-type: none;
        border-bottom: 1px solid ${colorsOptions.greys['grey-20']};
        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
`

export const MenuLinks = styled.span`
  text-decoration: none;
  padding: 7px 12px;
  color: ${colorsOptions.greys['grey-100']};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-L']]};
  display: block;
  cursor: pointer;
  background: ${colorsOptions.greys.white};
  width: 100%;
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  &:hover {
    background: ${colorsOptions.greys['grey-20']};
  }
  @media (max-width: 767px) {
    padding: 15px 12px;
  }
`

export const MenuLink = styled(Link)`
  text-decoration: none;
  padding: 7px 12px;
  color: ${colorsOptions.greys['grey-100']};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-L']]};
  display: block;
  cursor: pointer;
  background: ${colorsOptions.greys.white};
  width: 100%;
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  &:hover {
    background: ${colorsOptions.greys['grey-20']};
  }
  @media (max-width: 767px) {
    padding: 15px 12px;
  }
`

export const OptionsBlock = styled.div`
  margin-top: 40px;
  margin-bottom: 20px;
  &:after {
    content: '.';
    display: block;
    clear: both;
    visibility: hidden;
    line-height: 0;
    height: 0;
  }
  @media (max-width: 767px) {
    margin-top: 0;
    padding: 6px 8px 2px;
    border-bottom: 1px solid ${colorsOptions.greys['grey-30']};
    margin-bottom: 0;
  }
`

export const LeftBlock = styled.div`
  float: left;
  display: inline-block;
`

export const Content = styled.div`
  margin: 15px 0;
`

export const RightColumn = styled.div`
  float: right;
  display: inline-block;
  padding: 11px 0;
`

export const MediumText = styled.div`
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  color: ${colorsOptions.greys['grey-60']};
`

export const DarkText = styled.div`
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  color: ${colorsOptions.greys['grey-100']};
`
export const Row = styled.ul`
  &:after {
    content: '.';
    display: block;
    clear: both;
    visibility: hidden;
    line-height: 0;
    height: 0;
  }
`
export const Column = styled.li`
  &:hover {
    border: 1px solid ${colorsOptions.docuToolsOrange.orange};
  }
  border: 1px solid ${colorsOptions.greys['grey-10']};
  padding: 5px;
  cursor: pointer;
  margin-bottom: 26px;
  height: 90px;
  width: 23.5%;
  margin-right: 2%;
  float: left;
  &:nth-child(4n + 4) {
    margin-right: 0;
  }
  @media (min-width: 1440px) {
    width: 23.5%;
    margin-right: 2%;
    float: left;
    &:nth-child(4n + 4) {
      margin-right: 0;
    }
  }
  @media (min-width: 1025px) and (max-width: 1399px) {
    width: 32%;
    margin-right: 2%;
    float: left;
    &:nth-child(3n + 3) {
      margin-right: 0;
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    width: 49%;
    margin-right: 2%;
    float: left;
    &:nth-child(2n + 2) {
      margin-right: 0;
    }
  }

  @media (min-width: 320px) and (max-width: 767px) {
    width: 100%;
    margin-right: 0%;
    float: left;
  }
`

export const MemberPhoto = styled.div`
  float: left;
  height: 76px;
  width: 76px;
  overflow: hidden;
  @media (max-width: 767px) {
    width: 40px;
    height: 40px;
    border-radius: 40px;
  }
`

export const MemberInfo = styled.div`
  float: left;
  padding: 0 10px 8px;
  width: 65%;
  overflow: hidden;
`

export const TopInfoBlock = styled.div``

export const MemberName = styled.span`
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  color: ${colorsOptions.greys['grey-100']};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]};
  display: inline-block;
  margin-right: 6px;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  @media (max-width: 767px) {
    margin-right: 0;
  }
`

export const Tag = styled.span`
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]};
  color: ${colorsOptions.docuToolsOrange.orange};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]};
  display: inline-block;
  vertical-align: middle;
`

export const Designation = styled.div`
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]};
  color: ${colorsOptions.greys['grey-100']};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  margin-bottom: 10px;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  @media (max-width: 767px) {
    margin-right: 0;
    ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]};
    margin-bottom: 0;
  }
`
export const Contact = styled.div`
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]};
  color: ${colorsOptions.greys['grey-50']};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]};
  text-decoration: none;
  &:hover {
    color: ${colorsOptions.greys['grey-50']};
  }
`

export const Email = styled.div`
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]};
  color: ${colorsOptions.greys['grey-50']};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]};
`

export const LicenseWarning = styled.div`
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]};
  svg {
    margin-top: -2px;
  }
`

export const Header = styled.div`
  padding: 16px 10px 16px 16px;
  border-bottom: 1px solid ${colorsOptions.greys['grey-30']};
`

export const Title = styled.span`
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-L']]};
  color: ${colorsOptions.greys['grey-100']};
`
export const SubMenu = styled.div`
  margin-top: -10px;
  float: right;
`

export const SortingBlock = styled.div`
  padding: 10px 8px;
  border-bottom: 1px solid ${colorsOptions.greys['grey-30']};
  text-align: center;
  select {
    border: none;
    option {
      ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
    }
  }
`

export const SortText = styled.span`
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-400']]};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  color: ${colorsOptions.greys['grey-100']};
  padding-right: 8px;
  display: inline-block;
`

export const MainSection = styled.div`
  background: ${colorsOptions.greys.white};
`

export const MobileRow = styled.div`
  border-bottom: 1px solid ${colorsOptions.greys['grey-30']};
  padding: 7px 8px;
  &:after {
    content: '.';
    display: block;
    clear: both;
    visibility: hidden;
    line-height: 0;
    height: 0;
  }
`

export const MobileCol = styled.div`
  padding: 3px 0px 0 10px;
  float: left;
  width: 75%;
  @media (max-width: 767px) {
    width: 55%;
  }
`

export const EmailLink = styled.a`
  width: 40px;
  float: right;
  margin-right: 8px;
  height: 40px;
  border-radius: 40px;
  border: 1px solid ${colorsOptions.greys['grey-20']};
  display: inline-block;
  cursor: pointer;
`
export const PhoneLink = styled.a`
  width: 40px;
  float: right;
  height: 40px;
  border-radius: 40px;
  border: 1px solid ${colorsOptions.greys['grey-20']};
  display: inline-block;
  cursor: pointer;
`

export const UserEmailSuggest = styled.div`
  position: absolute;
  top: 0;
  border: 1px solid ${colorsOptions.greys['grey-60']};
  z-index: 10;
  background-color: ${colorsOptions.greys.white};
  width: 365px;
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-L']]};
`
export const Entry = styled.button`
  display: block;
  border-bottom: 1px solid ${colorsOptions.greys['grey-60']};
  cursor: pointer;
  background-color: ${({ selected }) =>
    selected ? colorsOptions.greys['grey-30'] : 'none'};
  padding: 7px 7px 7px 14px;
  width: 100%;
  text-align: left;
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  &:hover {
    background-color: ${colorsOptions.greys['grey-30']};
  }
  & .fullnames {
    font-weight: bold;
  }
  & .organisation {
    font-weight: normal;
    ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
    color: ${colorsOptions.greys['grey-50']};
  }
  & .email {
    ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]};
  }
`

export const SuggestWrapper = styled.div`
  position: relative;
`

export const EditDetailPopup = styled(PopupDefaultContainer)`
  max-width: 844px;
  width: 100%;
  @media (max-width: 870px) {
    width: 95%;
  }
`
export const ContentBlock = styled.div`
  width: 100%;
  background: ${colorsOptions.greys.white};
`
export const InsideBlock2 = styled.div`
  padding: 16px 16px;
`

export const InsideBlock = styled.div`
  padding: 16px 16px 16px 0px;
  margin-bottom: 25px;
  @media (max-width: 767px) {
    padding: 16px 0;
  }
`

export const TitleBar = styled.div`
  background: ${colorsOptions.greys['grey-10']};
  padding: 16px 10px 16px 16px;
  border-bottom: 1px solid ${colorsOptions.greys['grey-40']};
  span {
    ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
    color: ${colorsOptions.greys['grey-100']};
    ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-L']]};
  }
`

export const Close = styled.button`
  display: inline-block;
  vertical-align: top;
  cursor: pointer;
  height: 21px;
  width: 21px;
  overflow: hidden;
  float: right;
  text-align: center;
  cursor: pointer;
  margin-top: -2px;
  border-radius: 21px !important;
  &:hover {
    img {
      content: url('${clearTextIcon}');
    }
  }
`
export const FormControl = styled.div``
export const ButtonBlock = styled.div`
  text-align: right;
  background: ${colorsOptions.greys['grey-10']};
  padding: 10px 10px 10px 16px;
  border-top: 1px solid ${colorsOptions.greys['grey-40']};
  @media (max-width: 767px) {
    padding: 10px 8px;
  }
`

export const Cancel = styled(Button)`
  padding: 8px 37px;
  display: inline-block;
  color: ${colorsOptions.greys['grey-60']};
  text-align: center;
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-L']]};
  border-radius: 40px;
  border: 1px solid ${colorsOptions.greys['grey-30']};

  background: ${colorsOptions.greys.white};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  margin-right: 10px;

  &:hover {
    background: ${colorsOptions.greys['grey-20']};
    border-color: ${colorsOptions.greys['grey-30']};
    cursor: pointer;
  }
  &:disabled {
    background: none !important;
    opacity: 0.6;
    color: ${colorsOptions.greys['grey-50']};
    border: 1px solid ${colorsOptions.greys['grey-30']};
    cursor: not-allowed;
  }
  @media (max-width: 767px) {
    padding: 7px 27.5px;
    display: inline-block;
  }
`

export const Savebtn = styled(Button)`
  margin-left: 4px;
  padding: 8px 37px;
  display: inline-block;
  color: ${colorsOptions.greys['grey-100']};
  text-align: center;
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-L']]};
  border-radius: 40px;
  border: 1px solid ${colorsOptions.greys['grey-30']};

  background: ${colorsOptions.greys.white};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};

  &:hover {
    background: ${colorsOptions.greys['grey-20']};
    border-color: ${colorsOptions.greys['grey-30']};
    cursor: pointer;
  }
  &:disabled {
    background: none !important;
    opacity: 0.6;
    color: ${colorsOptions.greys['grey-50']};
    border: 1px solid ${colorsOptions.greys['grey-30']};
    cursor: not-allowed;
  }
  @media (max-width: 767px) {
    padding: 7px 27.5px;
    display: inline-block;
  }
`
export const VCardDownloadButton = styled.a`
  padding: 8px 37px;
  display: inline-block;
  color: ${colorsOptions.greys['grey-100']};
  text-align: center;
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-L']]};
  border-radius: 40px;
  width: 184px;
  border: 1px solid ${colorsOptions.greys['grey-30']};
  background: ${colorsOptions.greys.white};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  text-decoration: none;
  &:hover {
    background: ${colorsOptions.greys['grey-20']};
    border-color: ${colorsOptions.greys['grey-30']};
    cursor: pointer;
    text-decoration: none;
  }
  &:disabled {
    background: none !important;
    opacity: 0.6;
    color: ${colorsOptions.greys['grey-50']};
    border: 1px solid ${colorsOptions.greys['grey-30']};
    cursor: not-allowed;
  }
  @media (max-width: 767px) {
    padding: 7px 27.5px;
    display: inline-block;
  }
`
export const MessageTextArea = styled.textarea`
  width: 100%;
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-L']]};
  min-height: 39px;
  color: ${colorsOptions.greys['grey-100']};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  font-weight: normal;
  max-height: 100px;
  overflow: auto;
`

export const WriteMessage = styled(MessageTextArea)`
  height: 140px;
  max-height: 140px;
  margin-top: 17px;
`

export const SuggestSelectBox = styled.div`
  float: right;
  min-width: 200px;
  margin-bottom: 10px;
`

export const TagsWrapper = styled.div`
  margin-top: 5px;
  display: block;
`
export const OptionalBlock = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
`

export const CloseBtn = styled.button`
  display: inline-block;
  vertical-align: top;
  cursor: pointer;
  border-radius: 26px;
  height: 25px;
  width: 25px;
  overflow: hidden;
  float: right;
  text-align: center;
  margin-top: -3px;
  cursor: pointer;
`

export const ProfileSection = styled.div`
  text-decoration: none;
  padding: 0 0 16px 0;
  color: ${colorsOptions.greys['grey-100']};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-L']]};
  display: block;
  cursor: pointer;
  background: ${colorsOptions.greys.white};
  width: 100%;
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  border-bottom: 1px solid ${colorsOptions.greys['grey-20']};
  &:after {
    content: '.';
    display: block;
    clear: both;
    visibility: hidden;
    line-height: 0;
    height: 0;
  }
`

export const DetailSection = styled.div`
  float: left;
  padding: 16px 16px;
`
export const Name = styled.div`
  color: ${colorsOptions.greys['grey-100']};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-L']]};
  margin-bottom: 6px;
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]};
  word-wrap: break-word;
`

export const CloseSmallBtn = styled(Close)`
  display: inline-block;
  vertical-align: top;
  cursor: pointer;
  border-radius: 26px;
  height: 20px;
  width: 20px;
  overflow: hidden;
  margin-top: -0.5px;
  float: right;
  text-align: center;
  margin-right: -3px;
`

export const SearchTag = styled.span`
  display: inline-block;
  padding: 5px 15px;
  border: 1px solid ${colorsOptions.greys['grey-20']};
  border-radius: 29px;
  /*height:29px;*/
  margin-bottom: 5px;
  background-color: ${colorsOptions.greys['grey-20']};
  margin-right: 8px;
  @media (max-width: 767px) {
    max-width: 200px;
  }
  &:hover {
    span {
      color: ${colorsOptions.docuToolsOrange.orange};
    }
    border-color: ${colorsOptions.docuToolsOrange.orange};
  }
`

export const AddTag = styled(SearchTag)`
  padding: 5px 8px 5px 5px;
  margin-bottom: -11px;
`

export const Text = styled.span`
  display: inline-block;
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]};
  color: ${colorsOptions.greys['grey-100']};
  margin-right: 6px;
  vertical-align: top;
  @media (max-width: 767px) {
    max-width: 80%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`

export const TopSectionWrapper = styled.div`
  @media (max-width: 767px) {
    position: fixed;
    top: 50px;
    width: 100%;
    left: 0;
    z-index: 996;
    background: ${colorsOptions.greys['grey-10']};
  }
`

export const MiddleSectionWrapper = styled.div`
  margin-top: 95px;
  height: calc(100vh - 146px);
  overflow-y: auto;
`

export const Table = styled.table`
  width: 100%;
  table-layout: fixed;
  thead {
    width: 100%;
    tr {
      width: 100%;
      border: 1px solid ${colorsOptions.greys['grey-20']};
      th {
        color: ${colorsOptions.greys['grey-50']};
        ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
        ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
        text-align: left;
        padding: 9px 1%;
        background: ${colorsOptions.greys.white};
      }
    }
  }

  tbody {
    width: 100%;
    tr {
      height: 56px;
      width: 100%;
      min-height: 46px;
      background: ${colorsOptions.greys['grey-05']};
      border-right: 1px solid ${colorsOptions.greys['grey-20']};
      border-left: 1px solid ${colorsOptions.greys['grey-20']};
      &.customrowtwo {
        width: 100%;
        border: 0px !important;
        border-bottom: 1px solid ${colorsOptions.greys['grey-40']} !important;
        td {
          padding: 5px 2% !important;
        }
      }
      &:hover {
        background: ${colorsOptions.greys['grey-20']};
      }
      &:nth-child(even) {
        &:hover {
          background: ${colorsOptions.greys['grey-20']};
        }

        background: ${colorsOptions.greys.white};
        border: 1px solid ${colorsOptions.greys['grey-20']};
      }
      td {
        text-align: left;
        padding: 3px 1%;
        ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]};
        ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
        color: ${colorsOptions.greys['grey-100']};
        position: relative;
        @media (max-width: 767px) {
          ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
        }
        &.active {
          border-left: 5px solid ${colorsOptions.docuToolsOrange.orange};
        }
      }
    }
  }
`

export const TableEditBlock = styled.div`
  text-align: right;
`

export const TitleInTable = styled.span`
  cursor: pointer;
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  color: ${colorsOptions.greys['grey-100']};
  word-wrap: break-word;
  display: block;
  @media (max-width: 767px) {
    ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  }
`

export const ActiveText = styled.span`
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  color: ${colorsOptions.docuToolsOrange.orange};
  display: inline-block;
  padding: 10px;
  @media (max-width: 767px) {
    ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
    padding: 0;
  }
  &.nonactive {
    color: ${colorsOptions.greys['grey-40']};
  }
`

export const Subcontent = styled.span`
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  color: ${colorsOptions.greys['grey-60']};
  margin-left: 5px;
`

export const DropMenuBox = styled.ul`
  ${({ fixHeight }) => fixHeight && 'height: 46px'};
  float: right;
  list-style-type: none;
`

export const CheckBlock = styled.div`
  float: right;
  width: 20px;
  height: 20px;
  overflow: hidden;
  margin-top: 11px;
`

export const LastBlock = styled.td`
  text-align: left;
  padding: 0px 1% !important;
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  color: ${colorsOptions.greys['grey-100']};
`

export const EditMenuBtn = styled.a`
  color: ${colorsOptions.greys['grey-100']};
  display: inline-block;
  width: 40px;
  height: 40px;
  text-align: center;
  cursor: pointer;
  margin: 0 auto;
  letter-spacing: 1px;
`

export const SubMenuBlock = styled.li`
  cursor: pointer;
  position: relative;
  ul {
    display: block;
    list-style-type: none;
    padding: 0;
    margin: 0;
    position: absolute;
    top: 45px;
    left: auto;
    right: 0px;
    width: 200px;
    border: 1px solid ${colorsOptions.greys['grey-20']};
    box-shadow: 0px 1px 5px 0px rgba(20, 26, 33, 0.2);
    z-index: 99999999999;

    &:after {
      position: absolute;
      right: 8px;
      top: -11px;
      width: 0;
      height: 0;
      content: '';
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 10px solid ${colorsOptions.greys['grey-20']};
    }

    &:before {
      content: '';
      position: absolute;
      right: 8px;
      top: -9px;
      width: 0;
      height: 0;
      content: '';
      border-style: solid;
      border-width: 0 10px 10px 10px;
      border-color: transparent transparent #fff transparent;
      z-index: 3;
    }
    &:hover {
      &:before {
        border: none;
      }
    }
    li {
      list-style-type: none;
      text-align: right;
      border-bottom: 1px solid ${colorsOptions.greys['grey-20']};
      &:last-child {
        border-bottom: none;
      }
    }
  }
`

export const CheckBoxLink = styled.div`
  .moredetails {
    display: none;
  }
  &:hover {
    .moredetails {
      display: block;
      position: absolute;
      padding: 5px 8px;
      background: ${colorsOptions.greys['grey-30']};
      color: ${colorsOptions.greys['grey-100']};
      ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]};
      ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]};
      text-align: center;
      bottom: -33px;
      width: 100%;
      left: 0;
      border-radius: 10px;
      z-index: 99;
      -webkit-box-shadow: 0px 0px 19px -2px rgba(220, 220, 228, 0.97);
      -moz-box-shadow: 0px 0px 19px -2px rgba(220, 220, 228, 0.97);
      box-shadow: 0px 0px 19px -2px rgba(220, 220, 228, 0.97);
    }
  }
`
export const BoldContent = styled.span`
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  padding-left: 3px;
`

export const TagsSections = styled.div`
  margin-bottom: 15px;
  padding: 0px 16px;
`

export const TagTitle = styled.div`
  margin-bottom: 10px;
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]};
  color: ${colorsOptions.greys['grey-60']};
`

export const InnerTagBox = styled.div`
  border-bottom: 1px solid ${colorsOptions.greys['grey-20']};
  padding-bottom: 20px;
  padding-top: 5px;
`

export const CustomRow = styled.tr`
  width: 100%;
  border: 0px !important;
  border-bottom: 1px solid ${colorsOptions.greys['grey-40']} !important;
  th {
    padding: 9px 2% !important;
    cursor: default !important;
  }
`
export const BuyerMsgBox = styled.div`
  margin-bottom: 15px;
  padding: 0px 16px;
  margin-top: -16px;
`
export const InnerBox = styled.div`
  text-align: center;
  border: 1px solid ${colorsOptions.docuToolsOrange.orange};
  padding: 25px 0;
`

export const LimitationMessage = styled.div`
  color: ${colorsOptions.docuToolsOrange.orange};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-L']]};
  margin-bottom: 10px;
`
export const BuyBtn = styled(Button)`
  display: inline-block;
  padding: 5px 60px;
  border: 1px solid ${colorsOptions.greys['grey-20']};
  border-radius: 29px;
  height: 29px;
  margin-right: 8px;
  display: inline-block;
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  text-align: center;
`
export const ProfilePicture = styled.div`
  float: left;
  width: 60px;
  height: 60px;
  overflow: hidden;
`
export const Editbtn = styled(Savebtn)`
  float: right;
  margin-top: 13px;
`
export const PageSubTitle = styled.div`
  margin-top: 12px;
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  color: ${colorsOptions.greys['grey-60']};
`
export const InvitationDesc = styled.div`
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]};
`
export const ErrorMessage = styled.div`
  position: absolute;
  top: 0;
  padding: 10px;
  border: 1px solid ${colorsOptions.greys['grey-50']};
  z-index: 10;
  background-color: ${colorsOptions.greys.white};
`
export const SelectInput = styled.div`
  border-radius: 20px;
  background-color: #fff;
  border-color: #d9d9d9 #ccc #b3b3b3;
  border: 1px solid #ccc;
  color: #333;
  display: table;
  border-spacing: 0;
  border-collapse: separate;
  height: 36px;
  outline: none;
  overflow: hidden;
  position: relative;
  width: 200px;
  padding: 8px 5px 5px 16px;
  ${withProp(
    'marginBottom',
    (marginBottom) => `margin-bottom: ${marginBottom}px;`
  )}
  background: url("${dropdownArrow}") no-repeat;
  background-size: 14px 14px;
  background-position: 90% center;
  cursor: pointer;

  ${ifProp(
    'disabled',
    `
    opacity: 0.5;
    cursor: default;
  `
  )}
`

export const SelectText = styled.span``
export const DropDownWrapper = styled.ul``

export const SelectDropdown = styled.ul`
  display: block;
  position: fixed;
  background: ${colorsOptions.greys.white};
  z-index: 99999;
  padding: 0;
  margin: 4px 0 0;
  list-style: none;
  width: 250px;
  box-shadow: 0px 1px 5px 0px rgba(20, 26, 33, 0.2);
  &:after {
    content: '';
    position: absolute;
    left: 91.3%;
    top: -8px;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid ${colorsOptions.greys['grey-20']};
  }
  &:before {
    content: '';
    position: absolute;
    left: 91.3%;
    top: -9px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 10px 10px 10px;
    border-color: transparent transparent #fff transparent;
    z-index: 3;
  }
  @media (max-width: 477px) {
    width: 288px;
    right: 5px;
  }
`

export const SelectWrapper = styled.div`
  z-index: 1001;
  padding: 0;
  // float:left;
  list-style-type: none;
  position: relative;
  ul {
    display: block;
    float: none;
    position: absolute;
    top: 35px;
    right: 20px;
    background: ${colorsOptions.greys.white};
    z-index: 99999;
    padding: 0px;
    margin: 0;
    width: 250px;
    box-shadow: 0px 1px 5px 0px rgba(20, 26, 33, 0.2);

    &:after {
      content: '';
      position: absolute;
      left: 91.3%;
      top: -8px;
      width: 0;
      height: 0;
      content: '';
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 10px solid ${colorsOptions.greys['grey-20']};
    }

    &:before {
      content: '';
      position: absolute;
      left: 91.3%;
      top: -9px;
      width: 0;
      height: 0;
      content: '';
      border-style: solid;
      border-width: 0 10px 10px 10px;
      border-color: transparent transparent #fff transparent;
      z-index: 3;
    }

    @media (max-width: 477px) {
      width: 288px;
      right: 5px;
    }
  }
`

export const SettingsIcon = styled.button`
  cursor: pointer;
`

export const CustomSelectWrapper = styled.li`
  list-style-type: none;
  border-bottom: 1px solid ${colorsOptions.greys['grey-20']};
  padding: 12px 12px;
  cursor: ${({ noHover }) => (noHover ? '' : 'pointer')};
  &:after {
    font-size: 0px;
    line-height: 0px;
    height: 0px;
    content: '.';
    visibility: hidden;
    display: block;
    clear: both;
  }
  &:last-child {
    border-bottom: none;
  }
  ${({ noHover }) =>
    !noHover &&
    `&:hover {
        background: ${colorsOptions.greys['grey-30']};
       }`}
`

export const ItemIcon = styled.div`
  float: left;
  width: 20px;
  height: 20px;
  margin-right: 10px;
  overflow: hidden;
`

export const SelectContentBlock = styled.div`
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]};
  float: left;
  display: inline-block;
  width: 86%;
`
export const SelectTitle = styled.p`
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  padding: 0px 0px 0px 3px;
  color: ${colorsOptions.greys['grey-100']};
  word-wrap: break-word;
`

export const SubTitle = styled.div`
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]};
  padding: 0px 0px 0px 3px;
  color: ${colorsOptions.greys['grey-60']};
  &:hover {
    text-decoration: none;
  }
`
export const SelectAnchor = styled.a`
  color: ${colorsOptions.docuToolsOrange.orange};
  text-decoration: none;
  display: inline-block;
  cursor: pointer;
`
export const ReadMore = styled(HelpCenterLink)`
  color: ${colorsOptions.docuToolsOrange.orange};
  text-decoration: none;
  cursor: pointer;
  display: block;
  margin-top: 5px;
`
export const SelectHelpTitle = styled(SelectTitle)`
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]};
`

export const selectDropDownStyle = {
  control: (base) => ({
    ...base,
    minHeight: '38px!important'
  }),
  dropdownIndicator: (base) => ({
    ...base,
    opacity: 0
  })
}
